import { Injectable } from '@angular/core';
import { UiService } from '../../../core/services/core.ui.service';
import { HttpClient } from '@angular/common/http';
import { doGetPromise, doDeletePromise } from '../../../core/config/core.httpclient-utils';
import { TrackerFieldsService } from './tracker.fields.service';
import * as _ from 'lodash';

@Injectable()
export class TrackerWorkflowService {
    constructor(
        private http: HttpClient,
        private uiService: UiService,
        private trackerFieldsService: TrackerFieldsService
    ) {
    }

    private _prepareWorkflowForSave(workflow) {
        if (!_.isEmpty(workflow) && Array.isArray(workflow.fields)) {
            _.forEach(workflow.fields, (workflowField) => {
                _.forEach(workflowField.fieldElements, (fieldElement) => {
                    var ret: any = [];
                    _.forEach(fieldElement.toElements, (toElement: any) => {
                        if (toElement.isEnabled) {
                            delete toElement.isEnabled;
                            toElement.toLockStatus = this.trackerFieldsService.builtIn.lock_status.idToValue(toElement.toLockStatus);
                            ret.push(toElement);
                        }
                    });

                    fieldElement.toElements = ret;
                });
            });
        }
    }

    public delete(tracker_id, field_alias) {
        return new Promise((resolve, reject) => {
            doDeletePromise(this.http, `/api/tracker/${tracker_id}/workflow/?field=${field_alias}`)
            .then(() => {
                this.uiService.message.showSuccess('Workflow has been successfully disabled for field "' + field_alias + '"');
                resolve(null);
            })
            .catch(() => {
                this.uiService.message.showError("There were one or more errors trying to delete field " + field_alias);
                reject();
            });
        });
    }

    public save(tracker_id, workflow_field, enable_only: boolean = false) {
        var _workflow_field = _.cloneDeep(workflow_field);

        if (enable_only) {
            delete _workflow_field.fieldElements;
        }

        let data:any = {
                workflow: {
                    fields: []
                }
            };

        data.workflow.fields.push(_workflow_field);
        this._prepareWorkflowForSave(data.workflow);

        return new Promise((resolve, reject) => {
            this.http.post(`/api/tracker/${tracker_id}/workflow`, data)
            .toPromise()
            .then((response) => {
                this.uiService.message.showSuccess("Workflow has been successfully saved");
                resolve(response);
            }).catch((response) => {
                this.uiService.message.showError("There were one or more errors trying to when saving Tracker " + data.trackerName);
                reject(response);
            });
        }); 
    }

    public getFieldElementsByWorkflow(tracker, alias, elementId) {
        var field = _.get(tracker, 'fields.' + alias, null);

        if (!_.isEmpty(field)) {
            if (field.useWorkflow) {
                if (!_.has(tracker, 'rel.workflow')) {
                    return [];
                }
                var relatedField = _.find(tracker.rel.workflow.fields, {'alias': field.alias});
                var relatedElement = _.find(relatedField.fieldElements, {'id': elementId});
                if (!_.isEmpty(relatedElement) && relatedElement.toElements) {
                    return relatedElement.toElements;
                }
                return field.fieldElements;
            }
            return field.fieldElements;
        }
        return [];
    }
}